import {http_client} from "@/plugins/http_client";

const descargarDocumento = async (params) => { return await http_client('/api/v3/ascenso/descargar-documento-requerimientos', params, 'get') }

const generarDocumento = async (data) => { return await http_client('/api/v3/ascenso/generar-documento-requerimientos', data, 'post') }

const obtenerInformacionSolicitante = async () => 
  await http_client("/api/v3/ascenso/informacion-solicitante", {}, "get");

const visualizarInfoSolicitud = async (params) => 
  await http_client("/api/v3/ascenso/visualizar-solicitud", params, "get");

const obtenerPlazasSolicitante = async () => 
  await http_client("/api/v3/ascenso/plazas-disponibles", {}, "get");

const obtenerInformacionPersonal = async (params = {}) => 
  await http_client("/api/v3/ascenso/informacion-personal", params, "get");

const obtenerPlazasDisponibles = async (params = {}) => 
  await http_client("/api/v3/ascenso/plazas-con-ascensos-aprobados", params, "get");

const obtenerInformacionPlaza = async (id) => {
  return await http_client(`/api/v3/ascenso/visualizar-informacion-plaza`, { idPlaza: id }, "get");
}

const enviarRequerimientos = async (data) => 
  await http_client("/api/v3/ascenso/crear-requerimiento", data, "post", { headers: { "content-type": "multipart/form-data" },});

const obtenerDescriptoresPlaza = async (body) => 
  await http_client("/api/v3/ascenso/descriptores-plaza", body, "get");

const enviarSolicitudAscenso = async (body) => 
  await http_client(`/api/v3/ascenso/crear-solicitud`, body, "post");

const procesarSolicitudAscenso = async (body) => 
  await http_client(`/api/v3/ascenso/procesar-solicitud`, body, "post");

const index = async (params = {}) => 
  await http_client("/api/v3/ascenso/index", params, "get");

const empleadosSolicitudAprobada = async ( params = {} ) => 
  await http_client(`/api/v3/ascenso/empleados-solicitud-aprobada`, params, "get");

const listarEstadosSolicitudes = async () => 
  await http_client(`/api/v3/ascenso/listar-estados-solicitud`, {}, "get");

const visualizarInformacionRequerimiento = async ( params = {} ) => 
  await http_client(`/api/v3/ascenso/visualizar-requerimiento`, params, "get");

const obtenerEmpleadosEstablecimiento = async () => 
  await http_client("/api/v3/ascenso/listar-empleados-requerimiento", {}, "get");

const procesarRequerimiento = async ( body ) => 
  await http_client(`/api/v3/ascenso/procesar-requerimiento`, body, "post");

const pruebasRealizadas = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/documento/seleccion`, params, "get", {}, true, 'arraybuffer');

const iniciarProceso = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/iniciar-proceso`, params, "post");

const finalizarProceso = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/finalizar-proceso`, params, "post");

const enviarSolicitud = async ( body ) =>
  await http_client(`/api/v3/ascenso/enviar-solicitud`, body, "post");

const guardarDocumentoSeleccion = async ( body ) =>
  await http_client(`/api/v3/ascenso/documento/seleccion`, body, "post");

const getDocumentoSeleccion = async ( params ) =>
  await http_client(`/api/v3/ascenso/documento/seleccion`, params, "get");

const deleteDocumentoSeleccion = async ( params ) =>
  await http_client(`/api/v3/ascenso/documento/seleccion`, params, "delete");

const enviarResolucionFinal = async ( body ) =>
  await http_client(`/api/v3/ascenso/enviar-resolucion-final`, body, "post");

const verRequerimiento = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/descargar-documento-requerimientos`, params, "get");

const enviarActa = async ( body ) =>
  await http_client(`/api/v3/ascenso/enviar-documento-titular`, body, "post");

const descargarActa = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/modelo-acuerdo`, params, "get");

const procesarFaseFinal = async ( body ) =>
  await http_client(`/api/v3/ascenso/procesar-fase-final`, body, "post");

const obtenerTipoContratacion = async () =>
  await http_client(`/api/v3/ascenso/listar-tipos-contratacion`, {}, "get");

const listarEmpleados = async ( params = {} ) =>
  await http_client(`/api/v3/ascenso/listar-empleados`, params, "get");

export default {
  obtenerInformacionSolicitante,
  obtenerInformacionPersonal,
  obtenerPlazasSolicitante,
  descargarDocumento,
  obtenerPlazasDisponibles,
  obtenerInformacionPlaza,
  enviarRequerimientos,
  obtenerDescriptoresPlaza,
  enviarSolicitudAscenso,
  empleadosSolicitudAprobada,
  index,
  procesarSolicitudAscenso,
  pruebasRealizadas,
  visualizarInfoSolicitud,
  listarEstadosSolicitudes,
  visualizarInformacionRequerimiento,
  obtenerEmpleadosEstablecimiento,
  procesarRequerimiento,
  iniciarProceso,
  finalizarProceso,
  enviarSolicitud,
  guardarDocumentoSeleccion,
  getDocumentoSeleccion,
  deleteDocumentoSeleccion,
  enviarResolucionFinal,
  verRequerimiento,
  enviarActa,
  procesarFaseFinal,
  descargarActa,
  obtenerTipoContratacion,
  generarDocumento,
  listarEmpleados
}